export function buildResponseError(error) {
  return {
    message: error?.response?.data?.message || 'Erro inesperado, tente novamente.',
    status: error?.response?.status || 500,
  };
}
